import React from "react";
import { default as OpenTimeRegistrations } from "components/Dashboard/Dashboard_OpenTimeRegistrations"
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const Card_OpenTimeRegistrations = (props) => {
	// console.log(props);
	const { t } = useTranslation();

	return (
		<article className="card card-open-clockins">
			<div className="card-top">
				<h2>{t(WIDGET_NAMES[props.name])}</h2>
			</div>
			<div className="card-content">
				<OpenTimeRegistrations />
			</div>
		</article>
	);
};

export default Card_OpenTimeRegistrations;